import { defineStore, acceptHMRUpdate } from 'pinia'
import useState from './useState'
import useGetters from './useGetters'
import useActions from './useActions'
import { unref } from 'vue'

export const useExploreStore = defineStore('exploreStore', () => {
  const state = useState()
  const store = {
    initialState: unref(state),
    ...state,
    ...useGetters(),
    ...useActions(state)
  }
  // useWatchers(store)
  return store
})

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useExploreStore, import.meta.hot))
}
